import { Component } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { MatCard, MatCardContent } from '@angular/material/card';
import { SettingsService } from '../shared/services/settings.service';
import { XeroService } from '../shared/services/xero.service';
import { BrcSettingsService } from './brc-setup/brc-settings.service';
import { BrcSetupComponent } from './brc-setup/brc-setup.component';
import { DeliveryEstimateConfigComponent } from './delivery-estimate-config/delivery-estimate-config.component';
import { ImportExportComponent } from './import-export/import-export.component';
import { SageSettingsService } from './sage-setup/sage-settings.service';
import { SageSetupComponent } from './sage-setup/sage-setup.component';
import { StripeSetupComponent } from './stripe-setup/stripe-setup.component';
import { XeroSetupComponent } from './xero-setup/xero-setup.component';
import { ZohoSettingsService } from './zoho-setup/zoho-settings.service';
import { ZohoSetupComponent } from './zoho-setup/zoho-setup.component';
import { ConfigManagementService } from '../shared/services/config-management.service';

@Component({
  selector: 'settings',
  templateUrl: './settings.component.html',
  providers: [
    SettingsService,
    BrcSettingsService,
    SageSettingsService,
    XeroService,
    ZohoSettingsService,
    ConfigManagementService
  ],
  standalone: true,
  imports: [
    FlexModule,
    MatCard,
    MatCardContent,
    StripeSetupComponent,
    XeroSetupComponent,
    ZohoSetupComponent,
    SageSetupComponent,
    BrcSetupComponent,
    DeliveryEstimateConfigComponent,
    ImportExportComponent
  ]
})
export class SettingsComponent {
  constructor() {}
}
